export default "__VITE_ASSET__B6tcgsFG__"